import { useQuery } from '@tanstack/react-query'
import { getMigrationEligibleService } from 'selfServicePortal/services/MigrationServices/migrationService'

export const useMigrationEligible = () => {
	return useQuery(
		['migrationEligible'],
		() => getMigrationEligibleService(),
		{
			staleTime: Infinity,
			cacheTime: Infinity,
			refetchOnWindowFocus: false,
			retry: false,
		},
	)
}
